import { render, staticRenderFns } from "./language-not-listed.vue?vue&type=template&id=c53c8462&scoped=true&"
import script from "./language-not-listed.vue?vue&type=script&lang=js&"
export * from "./language-not-listed.vue?vue&type=script&lang=js&"
import style0 from "./language-not-listed.vue?vue&type=style&index=0&id=c53c8462&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53c8462",
  null
  
)

export default component.exports